import React from 'react';
import { FaCamera, FaCogs, FaClipboardList, FaShareAlt, FaLock } from 'react-icons/fa';
import './HowItWorks.css';

const HowItWorks = () => {
  const workflowSteps = [
    {
      number: 1,
      icon: <FaCamera />,
      title: 'Take a Photo',
      description: 'Capture wound image using your smartphone'
    },
    {
      number: 2,
      icon: <FaCogs />,
      title: 'AI Analysis',
      description: 'Our algorithms analyze the wound and accurately determine its area.'
    },
    {
      number: 3,
      icon: <FaClipboardList />,
      title: 'Get Results',
      description: 'View detailed assessment report'
    },
    {
      number: 4,
      icon: <FaShareAlt />,
      title: 'Share with Doctor',
      description: 'Send report to your healthcare provider'
    }
  ];
  
  return (
    <section id="how-it-works" className="how-it-works">
      <div className="container">
        <h2>How It Works</h2>
        <div className="workflow">
          {workflowSteps.map((step) => (
            <div key={step.number} className="workflow-step">
              <div className="step-number">{step.number}</div>
              <div className="step-icon">
                {step.icon}
              </div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
        
        <div className="tech-details">
          <h3>The Technology Behind Heal AI</h3>
          <p>
            Our deep learning models are trained on thousands of wound images and validated by
            medical professionals. We use a combination of convolutional neural networks and
            computer vision techniques to deliver accurate results with over 95% precision.
          </p>
          <div className="security-badge">
            <FaLock />
            <span>Secure & Privacy-Focused</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
